// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-datepicker-container {
  margin-top: 21px;
}
.report-datepicker-container label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
}
.report-datepicker-container input {
  border: none;
  border-radius: 5px;
  outline: none;
  text-indent: 4px;
  font-size: 16px;
  color: #666;
  width: calc(100% - 40px);
}

.report-datepicker-input-container {
  margin-top: 8px;
  display: flex;
  border: 1px solid #cccccc;
  border-radius: 5px;
  height: 40px;
  width: 200px;
}

.react-datepicker__input-container {
  position: relative;
  top: 10px;
}

.react-datepicker-wrapper,
.react-datepicker__input-container input,
.report-datepicker-input-container {
  cursor: pointer;
}

.filters .dropdown-container {
  margin-top: 10px;
  width: 100%;
}
.filters .dropdown-container .basic-single {
  width: 100%;
}
.filters .button--primary {
  margin-left: 16px;
  height: 56px;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.filters .button--primary span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
  padding: 3px;
  cursor: pointer;
}

.filters-report-page.basic-single {
  width: 200px;
  height: 40px;
}
.filters-report-page.basic-single .select__control {
  height: 40px !important;
}

.select__control {
  margin-bottom: 0 !important;
}

.input-field.no-margin {
  margin-top: 24px !important;
}

.reports_container .select__single-value {
  overflow: unset;
}
.reports_container .generic-report-filters {
  border: 1px solid #0abf53;
  box-shadow: 1px 1px 2px #444;
  padding: 10px;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.reports_container .generic-report-filters > * {
  flex: 1 1 160px;
}
.reports_container .generic-report-filters .input-field,
.reports_container .generic-report-filters .checkbox {
  padding: 0 2px;
  max-width: 200px;
}
.reports_container .generic-report-filters .input-field__label,
.reports_container .generic-report-filters .checkbox__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: 5px;
}
.reports_container .generic-report-filters .checkbox-field {
  display: flex;
  max-width: fit-content;
}
.reports_container .generic-report-filters .checkbox-field label {
  margin: unset;
}
.reports_container .generic-report-filters .report-filter-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-width: 150px;
  padding: 20px;
}
.reports_container .generic-report-filters .report-filter-buttons button {
  width: 70px;
  height: 40px;
  padding: 0;
  font-size: 12px;
  margin-right: 5px;
}
.reports_container .reports-datatable div[id*=row-]:last-child {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.reports_container .reports-datatable div[id*=row-]:hover {
  background-color: rgb(242.25, 242.25, 242.25);
}
.reports_container .reports-datatable div[id*=row-] div[id*=cell-] {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  overflow: hidden;
}
.reports_container .reports-datatable div[id*=row-] div[id*=cell-]:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.reports_container .reports-datatable .rdt_TableCol:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.reports_container .datepicker-container {
  margin-top: 5px;
  max-width: 200px;
  padding: 0 4px;
}
.reports_container .datepicker-container label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.reports_container .datepicker-container input {
  border: none;
  border-radius: 5px;
  outline: none;
  text-indent: 4px;
  font-size: 16px;
  color: #666;
  width: calc(100% - 40px);
}
.reports_container .datepicker-input-container {
  margin-top: 8px;
  display: flex;
  border: 1px solid #cccccc;
  border-radius: 5px;
  height: 50px;
  width: 200px;
}
.reports_container .datepicker-input-container .react-datepicker-wrapper {
  padding-top: 5px;
}
.reports_container h3 {
  font-size: 24px;
  font-weight: bold;
}
.reports_container p {
  line-height: 2;
}
.reports_container .main-content__result {
  padding: unset;
  min-width: 0 !important;
  padding-left: 40px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/Reports.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AADJ;AAIE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,wBAAA;AAFJ;;AAMA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;AAHF;;AAMA;;;EAGE,eAAA;AAHF;;AAOE;EACE,gBAAA;EACA,WAAA;AAJJ;AAMI;EACE,WAAA;AAJN;AAQE;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AANJ;AAQI;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AANN;;AAYE;EACE,YAAA;EACA,YAAA;AATJ;AAWI;EACE,uBAAA;AATN;;AAcA;EACE,2BAAA;AAXF;;AAcA;EACE,2BAAA;AAXF;;AAeE;EACE,eAAA;AAZJ;AAeE;EACE,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAbJ;AAeI;EACE,eAAA;AAbN;AAgBI;;EAEE,cAAA;EACA,gBAAA;AAdN;AAgBM;;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAbR;AAiBI;EACE,aAAA;EACA,sBAAA;AAfN;AAiBM;EACE,aAAA;AAfR;AAmBI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAjBN;AAmBM;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAjBR;AAwBM;EACE,4CAAA;AAtBR;AAyBM;EACE,6CAAA;AAvBR;AA0BM;EAKE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;AA5BR;AAoBQ;EACE,2CAAA;AAlBV;AA8BM;EACE,2CAAA;AA5BR;AAiCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA/BJ;AAiCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AA/BN;AAkCI;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,wBAAA;AAhCN;AAoCE;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAlCJ;AAoCI;EACE,gBAAA;AAlCN;AAsCE;EACE,eAAA;EACA,iBAAA;AApCJ;AAuCE;EACE,cAAA;AArCJ;AAwCE;EACE,cAAA;EACA,uBAAA;EACA,kBAAA;AAtCJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.report-datepicker-container {\n  margin-top: 21px;\n\n  label {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 14px;\n  }\n\n  input {\n    border: none;\n    border-radius: 5px;\n    outline: none;\n    text-indent: 4px;\n    font-size: 16px;\n    color: #666;\n    width: calc(100% - 40px);\n  }\n}\n\n.report-datepicker-input-container {\n  margin-top: 8px;\n  display: flex;\n  border: 1px solid #cccccc;\n  border-radius: 5px;\n  height: 40px;\n  width: 200px;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  top: 10px;\n}\n\n.react-datepicker-wrapper,\n.react-datepicker__input-container input,\n.report-datepicker-input-container {\n  cursor: pointer;\n}\n\n.filters {\n  .dropdown-container {\n    margin-top: 10px;\n    width: 100%;\n\n    .basic-single {\n      width: 100%;\n    }\n  }\n\n  .button--primary {\n    margin-left: 16px;\n    height: 56px;\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n\n    span {\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-align: left;\n      padding: 3px;\n      cursor: pointer;\n    }\n  }\n}\n\n.filters-report-page {\n  &.basic-single {\n    width: 200px;\n    height: 40px;\n\n    .select__control {\n      height: 40px !important;\n    }\n  }\n}\n\n.select__control {\n  margin-bottom: 0 !important;\n}\n\n.input-field.no-margin {\n  margin-top: 24px !important;\n}\n\n.reports_container {\n  .select__single-value {\n    overflow: unset;\n  }\n\n  .generic-report-filters {\n    border: 1px solid $primary-color;\n    box-shadow: 1px 1px 2px #444;\n    padding: 10px;\n    margin: 10px 0;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    >* {\n      flex: 1 1 160px;\n    }\n\n    .input-field,\n    .checkbox {\n      padding: 0 2px;\n      max-width: 200px;\n\n      &__label {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        padding-bottom: 5px;\n      }\n    }\n\n    .checkbox-field {\n      display: flex;\n      max-width: fit-content;\n\n      label {\n        margin: unset;\n      }\n    }\n\n    .report-filter-buttons {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      max-width: 150px;\n      padding: 20px;\n\n      button {\n        width: 70px;\n        height: 40px;\n        padding: 0;\n        font-size: 12px;\n        margin-right: 5px;\n      }\n    }\n  }\n\n  .reports-datatable {\n    div[id*=\"row-\"] {\n      &:last-child {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n      }\n\n      &:hover {\n        background-color: darken($color: white, $amount: 5%);\n      }\n\n      div[id*=\"cell-\"] {\n        &:not(:last-child) {\n          border-right: 1px solid rgba(0, 0, 0, 0.12);\n        }\n\n        display: -webkit-box;\n        -webkit-line-clamp: 3;\n        -webkit-box-orient: vertical;\n        -webkit-box-pack: center;\n        overflow: hidden;\n      }\n    }\n\n    .rdt_TableCol {\n      &:not(:last-child) {\n        border-right: 1px solid rgba(0, 0, 0, 0.12);\n      }\n    }\n  }\n\n  .datepicker-container {\n    margin-top: 5px;\n    max-width: 200px;\n    padding: 0 4px;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    input {\n      border: none;\n      border-radius: 5px;\n      outline: none;\n      text-indent: 4px;\n      font-size: 16px;\n      color: #666;\n      width: calc(100% - 40px);\n    }\n  }\n\n  .datepicker-input-container {\n    margin-top: 8px;\n    display: flex;\n    border: 1px solid #cccccc;\n    border-radius: 5px;\n    height: 50px;\n    width: 200px;\n\n    .react-datepicker-wrapper {\n      padding-top: 5px;\n    }\n  }\n\n  h3 {\n    font-size: 24px;\n    font-weight: bold;\n  }\n\n  p {\n    line-height: 2;\n  }\n\n  .main-content__result {\n    padding: unset;\n    min-width: 0 !important;\n    padding-left: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
